module.exports = __webpack_public_path__ + "img/cuba.41346d9a.svg";